import { Button, Table, TableBody, TableContainer, TableHead, TableRow } from "@mui/material";
import TableCellComponent from "components/table/TableCellComponent";
import TableRowComponent from "components/table/TableRowComponent";
import { HEADER_QUOTATION_LIST } from "constants/data";
import { useNavigate } from "react-router";
import { getUserType } from "util/auth";
import { formatPhoneNumber } from "utils";
import { QuotationQuery, TblQuote } from "../types/quotation";

/**
 * QuotationsTable component renders a table displaying a list of quotations.
 * @param {object} props - The component props.
 * @param {TblQuote[]} props.quoList - An array of quotation objects to be displayed in the table.
 * @param {QuotationQuery} props.queryParams - Query parameters for quotation filtering.
 * @returns {Element} The rendered QuotationsTable component.
 */
export default function QuotationsTable({
  quoList,
  queryParams,
}: {
  quoList: TblQuote[];
  queryParams: QuotationQuery;
}) {
  const navigate = useNavigate();
  const userType = getUserType();

  return (
    <TableContainer component={Table} sx={{ boxShadow: "none", minWidth: 1800, width: "100%" }}>
      <TableHead>
        <TableRowComponent data={HEADER_QUOTATION_LIST} type="header" />
      </TableHead>
      <TableBody>
        {quoList.map((quo, index) => (
          <TableRow key={quo.quote_no} className={index % 2 === 0 ? "even" : "odd"}>
            <TableCellComponent>{quo.store_cd}</TableCellComponent>
            <TableCellComponent>{quo.quote_no}</TableCellComponent>
            <TableCellComponent>{quo.quote_by}</TableCellComponent>
            <TableCellComponent>{quo.created_at}</TableCellComponent>
            <TableCellComponent>{quo.exp_date}</TableCellComponent>
            <TableCellComponent>{quo.customer_name}</TableCellComponent>
            <TableCellComponent>{formatPhoneNumber(quo.customer_tel_no, userType)}</TableCellComponent>
            <TableCellComponent>{quo.modl_name}</TableCellComponent>
            {/* <TableCellComponent>{quo.order_date}</TableCellComponent> */}
            <TableCellComponent>
              <Button
                variant="outlined"
                onClick={() => navigate(`/quotation/${quo.quote_id}`, { state: { queryParams } })}
                sx={{
                  border: "1px solid var(--gray-250)",
                  backgroundColor: "var(--white)",
                  color: "var(--black)",
                  fontSize: { xs: 16, md: 18, lg: 20 },
                  borderRadius: "4px",
                  width: { xs: "100%", lg: "158px" },
                  height: "40px",
                  whiteSpace: "pre",
                  boxShadow: "var(--shadow)",
                }}
              >
                詳細
              </Button>
            </TableCellComponent>
          </TableRow>
        ))}
      </TableBody>
    </TableContainer>
  );
}
